module.exports = __webpack_public_path__ + "img/glasses-10.52687ea2.svg";